import axios from "axios";
import { useState } from 'react';
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import { getPercentAskingPrice } from "../../utils/utils";
import AddOfferData from "./components/AddOfferData";


const initialData = {
  list_type: "",
  type_id: "",
  user_type: "buyer",
  offer_cap_rate: "",
  offer_price: "",
  property_name: "",
  asking_price: "",
  broker_buyer: "",
  bds_buyer: "",
  broker_seller: "",
  bds_seller: "",
  bds_buyer_id: "",
  bds_seller_id: "",
  br_seller_id: "",
  br_buyer_id: "",
  created_at: "",
  seller: "",
  buyer: "",
  property: "",
  offer_version: "",
  seller_options: "",
  buyer_options: "",
  broker_seller_type: "",
  broker_buyer_type: "",
  asking_cap_rate:"",
  asking_price:"",
  noi_rent:"",
};

const AddOfferModal = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);

    const percent_of_asking_price = getPercentAskingPrice(formData?.offer_price, formData?.asking_price)
    const commonData = {
      offer_price: formData?.offer_price,
      offer_cap_rate: formData?.offer_cap_rate,
      bds_seller: formData?.bds_seller_id,
      bds_buyer: formData?.bds_buyer_id,
      created_at: formData?.created_at,
      offer_version: formData?.offer_version,
      asking_price:formData?.asking_price,
      asking_cap_rate:formData?.asking_cap_rate,
      noi_rent:formData?.noi_rent,
      type: formData?.user_type,
      portfolio: formData?.portfolio === 1 ? 1 : 0,
      ...(formData.broker_seller_type === "inside" && { broker_inside_seller: formData.seller_exclusive_id }),
      ...(formData.broker_seller_type === "outside" && { broker_outside_seller: formData.seller_lead_id }),
      ...(formData.broker_buyer_type === "inside" && { broker_inside_buyer: formData.buyer_exclusive_id }),
      ...(formData.broker_buyer_type === "outside" && { broker_outside_buyer: formData.buyer_lead_id }),
    };

    const dataToSend = id === "" ? { ...commonData, contact_id: formData?.contact_id, seller: formData?.seller, buyer: formData?.buyer, property: formData?.property, percent_of_asking_price: percent_of_asking_price } : { ...commonData, offer_id: id };

    const url = id === "" ? "add-offer?type=new" : "add-offer";

    axios
      .post(`${BASE_URL}/${url}`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <Modal width="620px" title={`Add Offer`} desc={`Add the offer information.`} show={showModal} onClose={handleClose}>
      <AddOfferData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        showModal={showModal}
        from={id === "" ? "new" : "update"}
        disable={disable}
      />
    </Modal>
  );
};

export default AddOfferModal;
